import { render, staticRenderFns } from "./TripDataTable.vue?vue&type=template&id=0768e884"
import script from "./TripDataTable.vue?vue&type=script&lang=js"
export * from "./TripDataTable.vue?vue&type=script&lang=js"
import style0 from "./TripDataTable.vue?vue&type=style&index=0&id=0768e884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports